import { useEffect, useState } from "react";
import { t } from "../i18n.ts";
import { useOpsPending } from "../opsQueue.ts";
import { useSync } from "../store.ts";

export function StatusBar() {
  const { status, pending, rejected } = useSync();
  const opsPending = useOpsPending();
  const [showRejected, setShowRejected] = useState(false);

  useEffect(() => {
    if (!rejected || status === "unauthorized") return;
    setShowRejected(true);
    const timer = setTimeout(() => setShowRejected(false), 4000);
    return () => clearTimeout(timer);
  }, [rejected, status]);

  if (status === "unauthorized") return <div className="banner banner-error">{rejected === "err.blocked" ? t("err.blocked") : t("unauthorized")}</div>;
  if (showRejected) return <div className="banner banner-error">{t("rejected")}</div>;
  if (status === "offline") {
    return (
      <div className="banner banner-warn">
        {t("offline")}
        {pending + opsPending > 0 && <span className="banner-count">{t("pending", { n: pending + opsPending })}</span>}
      </div>
    );
  }
  if (status === "loading") return <div className="banner">{t("loading")}</div>;
  // Списки на связи, а записи операций ещё ждут: например, сеть только что появилась.
  if (opsPending > 0) return <div className="banner banner-warn">{t("opsPending", { n: opsPending })}</div>;
  return null;
}
